import { render, staticRenderFns } from "./RequisicaoGeracaoTable.vue?vue&type=template&id=a198bf34&"
import script from "./RequisicaoGeracaoTable.vue?vue&type=script&lang=js&"
export * from "./RequisicaoGeracaoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports